module.exports = __webpack_public_path__ + "static/img/15.26c7f5b5.jpg";